import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Bar } from 'react-chartjs-2';
import { Chart, BarElement, Legend, LinearScale, Tooltip, CategoryScale } from 'chart.js';
import { getRelativePosition } from 'chart.js/helpers';

Chart.register(BarElement, Legend, LinearScale, Tooltip, CategoryScale);

// Adds extra functionality to the default horizontal chart
export default class ExtendedHorizontalBar extends Component {
  constructor(props) {
    super(props);
    this.chartRef = React.createRef();
  }

  static propTypes = {
    options: PropTypes.shape({}),
    onLabelClick: PropTypes.func,
    onElementClick: PropTypes.func,
  };
  static defaultProps = {
    options: {},
    onLabelClick: index => {},
    onElementClick: element => {},
  };
  handleChartClick = event => {
    const { onLabelClick, onElementClick } = this.props;
    if (!this.chartRef.current) return;
    const [element] = this.chartRef.current.getElementsAtEventForMode(
      event,
      'nearest',
      { intersect: true },
      false,
    );
    if (element) {
      onElementClick(element);
      return;
    }
    const mousePoint = getRelativePosition(event, this.chartRef.current);
    const scale = this.chartRef.current.scales.y;
    if (
      scale.top > mousePoint.y ||
      scale.bottom < mousePoint.y ||
      scale.left > mousePoint.x ||
      scale.right < mousePoint.x
    )
      return; // Clicked outside of the y-axis
    const index = scale.getValueForPixel(mousePoint.y);
    onLabelClick(index);
  };

  render() {
    const { options, onLabelClick, onElementClick, ...rest } = this.props;
    return <Bar {...rest} options={options} onClick={this.handleChartClick} ref={this.chartRef} />;
  }
}
